import useSWRMutation from 'swr/mutation'

import type { HttpMethod, StringObject } from '~/core/@types/global'
import { DEFAULT_LOCALE } from '~/core/constants/env'
import { useApiRequest } from '~/core/hooks/use-api'

function useMiddlewareRequest({
  endpoint,
  method,
  locale = DEFAULT_LOCALE,
  headers
}: {
  endpoint: string
  method?: HttpMethod
  locale: string
  headers?: StringObject
}) {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  const fetcher = useApiRequest<void, object>()

  return useSWRMutation(endpoint, (path, { arg }: { arg: object }) => {
    return fetcher({
      path,
      body: arg,
      method,
      extraParams: {
        language: locale || DEFAULT_LOCALE,
        timezone: timeZone
      },
      headers
    })
  })
}

export default useMiddlewareRequest
